import { create } from 'zustand'
import api, { endpoints } from '../../../shared/api'

export const useProductSearchStore = create((set) => ({
    isLoading: false,
    active: false,
    products: [],
    suggestions: 0,
    value: '',
    error: null,
    setValue: (value) => set((state) => ({ value, value })),
    setActive: (value) => set((state) => ({ active: value })),
    focused: false,
    setFocused: (value) => set((state) => ({ focused: value })),
    resetProducts: () => set({ products: [] }),
    fetchProducts: async (value) => {
        set({ isLoading: true })
        try {
            const response = await api.get(endpoints.product_search(value))
            const products = response.data.products
            set({
                isLoading: false,
                products: products,
                suggestions: response.data.suggestions,
                error: null,
                active: true,
            })
        } catch (error) {
            set({ error })
        }
    },
}))

if (process.env.NODE_ENV === 'development') {
}
